/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/internalSearchFlagsOverrides';

export type InternalSearchFlagsPathParams = NonNullable<operations['internalSearchFlags']['parameters']['path']>;

export type InternalSearchFlagsQueryParams = NonNullable<operations['internalSearchFlags']['parameters']['query']>;

export type InternalSearchFlagsRequestBody = OperationRequestBodyContent<operations['internalSearchFlags']>;

export interface Input extends InternalSearchFlagsPathParams {
  apiVersion?: string;
  query?: InternalSearchFlagsQueryParams;
  body: InternalSearchFlagsRequestBody;
}

export async function internalSearchFlags(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/flags/search', {
    params: { path, query },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
